<template>
	<div class="container-fluid">
		<!-- BUSCADOR -->
		<div class="card" style="margin-top: 10px;">
			<div class="card-header bg-info text-white">
				Buscar contactos
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<b>Nombre/apellidos/teléfono/email</b>
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<span class="fa fa-user"></span>
								</span>
							</div>
							<input type="text" class="form-control" placeholder="Nombre del contacto a buscar" v-model="filtro.nombre" @keypress.enter="buscar()">
						</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<div class="row">
							<div class="col">
								<b>Cargo</b>
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-user"></span>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="Cargo que ostenta" v-model="filtro.cargo" @keypress.enter="buscar()">
								</div>
							</div>
							<div class="col">
								<b>Organización</b>
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-user"></span>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="Organización a la que pertenece" v-model="filtro.organizacion" @keypress.enter="buscar()">
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<b>Libreta</b>
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<span class="fa fa-list"></span>
								</span>
							</div>
							<select name="" id="" class="form-control" v-model="filtro.ID_libreta" @change="buscar()">
								<option :value="null">En todas las libretas</option>
								<option :value="libreta.ID_libreta" v-for="libreta in listadoLibretas" :key="libreta.ID_libreta">{{libreta.nombre}}</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body bg-light">
				<b>Ordenación</b>
				<br>
				<div class="capaOrdenacion" v-for="(dimension, index) in filtro.ordenar" :key="dimension.id">
					<div class="input-group">
						<div class="input-group-append" v-if="index > 0">
							<button class="btn btn-danger" @click="filtro.ordenar.splice(index, 1)">
								<span class="fa fa-trash"></span>
							</button>
						</div>
						<select name="" id="" class="form-control" v-model="filtro.ordenar[index].campo">
							<option :value="null"></option>
							<option :value="campo.campo" v-for="campo in listadoCamposOrdena" :key="campo.campo">{{campo.nombre}}</option>
						</select>
						<div class="input-group-append">
							<button class="btn" :class="(dimension.tipo === 'asc') ? 'btn-primary' : 'btn-default'" @click="filtro.ordenar[index].tipo = 'asc'">
								ASC
							</button>
							<button class="btn" :class="(dimension.tipo === 'desc') ? 'btn-primary' : 'btn-default'" @click="filtro.ordenar[index].tipo = 'desc'">
								DESC
							</button>
							<button class="ml-3 btn btn-warning" @click="filtro.ordenar.push({tipo: 'asc', campo: 'nombre'})" v-if="index === filtro.ordenar.length - 1">
								<span class="fa fa-plus"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="row">
					<div class="col text-left">
						<button class="btn btn-sm btn-primary" @click="buscar()">
							<span class="fa fa-search mr-2"></span>
							Buscar
						</button>
						<button class="btn btn-sm btn-warning" @click="nuevoContacto()">
							<span class="fa fa-user mr-2"></span>
							Nuevo contacto
						</button>
					</div>
					<div class="col text-right">
						<button class="btn btn-sm btn-info" @click="gestion_libretas = true">
							<span class="fa fa-list mr-2"></span>
							Gestionar libretas
						</button>
					</div>
				</div>
			</div>
		</div>

		<editor-contacto v-if="contacto" :datos="contacto" @cerrar="contacto = null"></editor-contacto>
		<detalles-registro v-if="detalles" :idregistro="detalles" @cerrar="detalles = null" @editar="editar($event)"></detalles-registro>
		<gestion-libretas v-if="gestion_libretas" @cerrar="gestion_libretas = false"></gestion-libretas>
		<!-- //// FIN BUSCADOR -->

		<!-- RESULTADOS -->
		<div class="card mt-2">
			<div class="card-header bg-info text-white">
				Resutados
			</div>
			<div class="table-responsive">
				<table class="table table-condensed table-striped m-0">
					<thead>
						<tr>
							<th>Nombre</th>
							<th>Organización</th>
							<th>Teléfono</th>
							<th>E-mail</th>
							<th>Libreta(s)</th>
							<th>Opciones</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="registro in resultados" :key="registro.ID_registro">
							<td>
								{{registro.nombre}}
								{{registro.apellidos}}
							</td>
							<td>
								<div v-for="org in registro.organizaciones" :key="org.ID_organizacion">
									{{org.cargo}} en {{org.nombre}}
								</div>
							</td>
							<td>
								<div v-if="registro.telefonos.length > 0">
									{{registro.telefonos[0].telefono}}
								</div>
							</td>
							<td>
								<div v-if="registro.emails.length > 0">
									<a :href="'mailto:'+registro.emails[0].email">{{registro.emails[0].email}}</a>
								</div>
							</td>
							<td>
								<div v-for="libreta in registro.libretas" :key="libreta.ID_libreta">
									{{libreta.nombre}}
								</div>
							</td>
							<td>
								<button class="btn btn-sm btn-primary" @click="detalles = registro.ID_registro">
									<span class="fa fa-eye"></span>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- //// FIN DE RESULTADOS -->
	</div>
</template>

<script>
import EditorContactos from './editor-contacto'
import DetalleRegistro from './detalles-registro'
import GestionLibretas from '../libretas/gestion-libretas'

import API from '../service'
export default {
	components: {
		'editor-contacto': EditorContactos,
		'detalles-registro': DetalleRegistro,
		'gestion-libretas': GestionLibretas
	},
	data () {
		return {
			resultados: [],
			filtro: {
				ID_libreta: null,
				nombre: '',
				organizacion: '',
				cargo: '',
				ordenar: [
					{
						campo: 'nombre',
						tipo: 'asc'
					}
				]
			},
			listadoLibretas: [],
			listadoCamposOrdena: [
				{
					campo: 'nombre',
					nombre: 'Nombre'
				},
				{
					campo: 'apellidos',
					nombre: 'Apellidos'
				},
				{
					campo: 'cargo',
					nombre: 'Cargo'
				},
				{
					campo: 'organizacion',
					nombre: 'Organización'
				},
				{
					campo: 'libreta',
					nombre: 'Libreta'
				}
			],
			contacto: null,
			detalles: null,
			gestion_libretas: false
		}
	},

	created () {
		this.buscar()

		API.getLibretas()
			.then(res => {
				this.listadoLibretas = res.data.libretas
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	methods: {
		buscar () {
			API.buscarRegistros(this.filtro)
				.then(res => {
					this.resultados = res.data.registros
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevoContacto () {
			console.log('Nuevo contacto')
			this.contacto = 'nuevo'
		},

		editar (idRegistro) {
			this.contacto = idRegistro
			this.detalles = null
		}
	}
}
</script>


<style scoped>
 .capaOrdenacion {
	 position: relative;
	 display: inline-block;
	 width: 100%;
	 max-width: 350px;
	 margin-right: 10px;
	 margin-bottom: 10px;
 }
</style>



// WEBPACK FOOTER //
// src/modulos/libreta-direcciones/vue/contactos/contactos.vue